/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/dev'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedUnitsRouteImport } from './routes/_authenticated/units'
import { Route as AuthenticatedStudentsRouteImport } from './routes/_authenticated/students'
import { Route as AuthenticatedPlayingTimeRouteImport } from './routes/_authenticated/playing-time'
import { Route as AuthenticatedLabsReviewsRouteImport } from './routes/_authenticated/labs-reviews'
import { Route as AuthenticatedInstallTimesRouteImport } from './routes/_authenticated/install-times'
import { Route as AuthenticatedGamesRouteImport } from './routes/_authenticated/games'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedActivityLibraryRouteImport } from './routes/_authenticated/activity-library'
import { Route as AuthenticatedAchievementsRouteImport } from './routes/_authenticated/achievements'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedUnitsIndexRouteImport } from './routes/_authenticated/units/index'
import { Route as AuthenticatedUnitsUnitIdRouteImport } from './routes/_authenticated/units/$unitId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUnitsRoute = AuthenticatedUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStudentsRoute = AuthenticatedStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlayingTimeRoute =
  AuthenticatedPlayingTimeRouteImport.update({
    id: '/playing-time',
    path: '/playing-time',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLabsReviewsRoute =
  AuthenticatedLabsReviewsRouteImport.update({
    id: '/labs-reviews',
    path: '/labs-reviews',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstallTimesRoute =
  AuthenticatedInstallTimesRouteImport.update({
    id: '/install-times',
    path: '/install-times',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGamesRoute = AuthenticatedGamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityLibraryRoute =
  AuthenticatedActivityLibraryRouteImport.update({
    id: '/activity-library',
    path: '/activity-library',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAchievementsRoute =
  AuthenticatedAchievementsRouteImport.update({
    id: '/achievements',
    path: '/achievements',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUnitsIndexRoute = AuthenticatedUnitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUnitsRoute,
} as any)
const AuthenticatedUnitsUnitIdRoute =
  AuthenticatedUnitsUnitIdRouteImport.update({
    id: '/$unitId',
    path: '/$unitId',
    getParentRoute: () => AuthenticatedUnitsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AuthenticatedAccountRoute
  '/achievements': typeof AuthenticatedAchievementsRoute
  '/activity-library': typeof AuthenticatedActivityLibraryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/games': typeof AuthenticatedGamesRoute
  '/install-times': typeof AuthenticatedInstallTimesRoute
  '/labs-reviews': typeof AuthenticatedLabsReviewsRoute
  '/playing-time': typeof AuthenticatedPlayingTimeRoute
  '/students': typeof AuthenticatedStudentsRoute
  '/units': typeof AuthenticatedUnitsRouteWithChildren
  '/units/$unitId': typeof AuthenticatedUnitsUnitIdRoute
  '/units/': typeof AuthenticatedUnitsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AuthenticatedAccountRoute
  '/achievements': typeof AuthenticatedAchievementsRoute
  '/activity-library': typeof AuthenticatedActivityLibraryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/games': typeof AuthenticatedGamesRoute
  '/install-times': typeof AuthenticatedInstallTimesRoute
  '/labs-reviews': typeof AuthenticatedLabsReviewsRoute
  '/playing-time': typeof AuthenticatedPlayingTimeRoute
  '/students': typeof AuthenticatedStudentsRoute
  '/units/$unitId': typeof AuthenticatedUnitsUnitIdRoute
  '/units': typeof AuthenticatedUnitsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/dev': typeof DevRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/achievements': typeof AuthenticatedAchievementsRoute
  '/_authenticated/activity-library': typeof AuthenticatedActivityLibraryRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/games': typeof AuthenticatedGamesRoute
  '/_authenticated/install-times': typeof AuthenticatedInstallTimesRoute
  '/_authenticated/labs-reviews': typeof AuthenticatedLabsReviewsRoute
  '/_authenticated/playing-time': typeof AuthenticatedPlayingTimeRoute
  '/_authenticated/students': typeof AuthenticatedStudentsRoute
  '/_authenticated/units': typeof AuthenticatedUnitsRouteWithChildren
  '/_authenticated/units/$unitId': typeof AuthenticatedUnitsUnitIdRoute
  '/_authenticated/units/': typeof AuthenticatedUnitsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/login'
    | '/signup'
    | '/account'
    | '/achievements'
    | '/activity-library'
    | '/dashboard'
    | '/games'
    | '/install-times'
    | '/labs-reviews'
    | '/playing-time'
    | '/students'
    | '/units'
    | '/units/$unitId'
    | '/units/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dev'
    | '/login'
    | '/signup'
    | '/account'
    | '/achievements'
    | '/activity-library'
    | '/dashboard'
    | '/games'
    | '/install-times'
    | '/labs-reviews'
    | '/playing-time'
    | '/students'
    | '/units/$unitId'
    | '/units'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/dev'
    | '/login'
    | '/signup'
    | '/_authenticated/account'
    | '/_authenticated/achievements'
    | '/_authenticated/activity-library'
    | '/_authenticated/dashboard'
    | '/_authenticated/games'
    | '/_authenticated/install-times'
    | '/_authenticated/labs-reviews'
    | '/_authenticated/playing-time'
    | '/_authenticated/students'
    | '/_authenticated/units'
    | '/_authenticated/units/$unitId'
    | '/_authenticated/units/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  DevRoute: typeof DevRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/units': {
      id: '/_authenticated/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof AuthenticatedUnitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/students': {
      id: '/_authenticated/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof AuthenticatedStudentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playing-time': {
      id: '/_authenticated/playing-time'
      path: '/playing-time'
      fullPath: '/playing-time'
      preLoaderRoute: typeof AuthenticatedPlayingTimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/labs-reviews': {
      id: '/_authenticated/labs-reviews'
      path: '/labs-reviews'
      fullPath: '/labs-reviews'
      preLoaderRoute: typeof AuthenticatedLabsReviewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/install-times': {
      id: '/_authenticated/install-times'
      path: '/install-times'
      fullPath: '/install-times'
      preLoaderRoute: typeof AuthenticatedInstallTimesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/games': {
      id: '/_authenticated/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof AuthenticatedGamesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity-library': {
      id: '/_authenticated/activity-library'
      path: '/activity-library'
      fullPath: '/activity-library'
      preLoaderRoute: typeof AuthenticatedActivityLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/achievements': {
      id: '/_authenticated/achievements'
      path: '/achievements'
      fullPath: '/achievements'
      preLoaderRoute: typeof AuthenticatedAchievementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/units/': {
      id: '/_authenticated/units/'
      path: '/'
      fullPath: '/units/'
      preLoaderRoute: typeof AuthenticatedUnitsIndexRouteImport
      parentRoute: typeof AuthenticatedUnitsRoute
    }
    '/_authenticated/units/$unitId': {
      id: '/_authenticated/units/$unitId'
      path: '/$unitId'
      fullPath: '/units/$unitId'
      preLoaderRoute: typeof AuthenticatedUnitsUnitIdRouteImport
      parentRoute: typeof AuthenticatedUnitsRoute
    }
  }
}

interface AuthenticatedUnitsRouteChildren {
  AuthenticatedUnitsUnitIdRoute: typeof AuthenticatedUnitsUnitIdRoute
  AuthenticatedUnitsIndexRoute: typeof AuthenticatedUnitsIndexRoute
}

const AuthenticatedUnitsRouteChildren: AuthenticatedUnitsRouteChildren = {
  AuthenticatedUnitsUnitIdRoute: AuthenticatedUnitsUnitIdRoute,
  AuthenticatedUnitsIndexRoute: AuthenticatedUnitsIndexRoute,
}

const AuthenticatedUnitsRouteWithChildren =
  AuthenticatedUnitsRoute._addFileChildren(AuthenticatedUnitsRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedAchievementsRoute: typeof AuthenticatedAchievementsRoute
  AuthenticatedActivityLibraryRoute: typeof AuthenticatedActivityLibraryRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedGamesRoute: typeof AuthenticatedGamesRoute
  AuthenticatedInstallTimesRoute: typeof AuthenticatedInstallTimesRoute
  AuthenticatedLabsReviewsRoute: typeof AuthenticatedLabsReviewsRoute
  AuthenticatedPlayingTimeRoute: typeof AuthenticatedPlayingTimeRoute
  AuthenticatedStudentsRoute: typeof AuthenticatedStudentsRoute
  AuthenticatedUnitsRoute: typeof AuthenticatedUnitsRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedAchievementsRoute: AuthenticatedAchievementsRoute,
  AuthenticatedActivityLibraryRoute: AuthenticatedActivityLibraryRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedGamesRoute: AuthenticatedGamesRoute,
  AuthenticatedInstallTimesRoute: AuthenticatedInstallTimesRoute,
  AuthenticatedLabsReviewsRoute: AuthenticatedLabsReviewsRoute,
  AuthenticatedPlayingTimeRoute: AuthenticatedPlayingTimeRoute,
  AuthenticatedStudentsRoute: AuthenticatedStudentsRoute,
  AuthenticatedUnitsRoute: AuthenticatedUnitsRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  DevRoute: DevRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
